import { ComboboxData } from '@mantine/core';

export const periodList: ComboboxData = [
  {
    label: 'Last 7 Days',
    value: '7'
  },
  {
    label: 'Last 28 Days',
    value: '28'
  },
  {
    label: 'Last 3 Months',
    value: '3'
  },
  {
    label: 'Last 6 Months',
    value: '6'
  },
  {
    label: 'Last 12 Months',
    value: '12'
  },
  {
    label: 'Custom Period',
    value: 'custom'
  }
];
export const statusList: ComboboxData = [
  { label: 'All', value: '' },
  { label: 'On Progress', value: 'on progress' },
  { label: 'Complete', value: 'complete' }
];
